import store from '@/store'
import Action from '@/store/model/sport/football/Action'
import Match from '@/store/model/sport/football/Match'

export default {
  load: (state, data) => {
    for (const i in data) {
      const dataMatch = data[i]

      const teams = []
      if (dataMatch.teamHome) {
        teams.push(dataMatch.teamHome)
      }
      if (dataMatch.teamAway) {
        teams.push(dataMatch.teamAway)
      }
      if (teams.length > 0) {
        store.commit('Sport/Football/Team/load', teams)
      }

      const newMatch = new Match(dataMatch)

      const foundMatch = state.matchs.find((match) => { return match.id === newMatch.id })
      if (foundMatch) {
        Object.assign(foundMatch, newMatch)
      } else {
        state.matchs.push(newMatch)
      }

      for (const j in state.actions) {
        if (state.actions[j].matchId === dataMatch.id) {
          state.actions.splice(j, 1)
        }
      }

      if (dataMatch.actions) {
        for (const j in dataMatch.actions) {
          state.actions.push(new Action(dataMatch.actions[j], newMatch))
        }
      }

      store.commit('Sport/Football/Match/loadMatchActionsStatistics', newMatch)
      store.commit('Sport/Football/Match/loadMatchActionsStopwatch', newMatch)
    }
  },
  loadMatch (state, data) {
    for (const i in data) {
      const dataMatch = data[i]
      const foundMatch = state.matchs.find((match) => { return match.id === dataMatch.id })
      if (foundMatch) {
        foundMatch.setData(dataMatch)
      } else {
        const newMatch = new Match(dataMatch)
        state.matchs.push(newMatch)
      }
    }
  },
  loadAction (state, data) {
    const matchesId = new Set()
    const matches = new Set()
    for (const i in data) {
      const dataAction = data[i]
      const foundMatch = state.matchs.find((match) => { return match.id === dataAction.matchId })
      if (foundMatch) {
        if (matchesId.has(foundMatch.id) === false) {
          matchesId.add(foundMatch.id)
          matches.add(foundMatch)
        }
        const newAction = new Action(dataAction, foundMatch)
        const foundAction = state.actions.find((action) => { return action.id === newAction.id })
        if (foundAction) {
          Object.assign(newAction, { open: foundAction.open })
          Object.assign(foundAction, newAction)
        } else {
          newAction.open = true
          state.actions.push(newAction)
        }
      }
    }

    matches.forEach((match) => {
      store.commit('Sport/Football/Match/loadMatchActionsStatistics', match)
      store.commit('Sport/Football/Match/loadMatchActionsStopwatch', match)
    })
  },
  loadMatchActionsStatistics (state, match) {
    const actions = state.actions.filter(
      (action) => action.matchId === match.id && action.active === true && action.canceled === false
    )

    const statistics = {
      id: match.id,
      shotInHome: 0,
      shotInAway: 0,
      shotOutHome: 0,
      shotOutAway: 0,
      freekickHome: 0,
      freekickAway: 0,
      cornerHome: 0,
      cornerAway: 0,
      offsideHome: 0,
      offsideAway: 0,
      foulHome: 0,
      foulAway: 0
    }

    for (const i in actions) {
      const action = actions[i]
      let team
      if (action.teamId === match.teamHomeId) {
        team = 'Home'
      }
      if (action.teamId === match.teamAwayId) {
        team = 'Away'
      }

      if (team) {
        if (action.typeId === 1 && action.destinationId === 1) {
          statistics['shotIn' + team]++
        }
        if (action.typeId === 1 && [2, 3, 4].indexOf(action.destinationId) > -1) {
          statistics['shotOut' + team]++
        }
        if ([2, 3, 4, 12].indexOf(action.originId) > -1) {
          statistics['freekick' + team]++
        }
        if ([13].indexOf(action.originId) > -1) {
          statistics['corner' + team]++
        }
        if (action.typeId === 11) {
          statistics['foul' + team]++
        }
      }
    }

    const found = state.matchsActionsStatistics.find((matchSearch) => { return match.id === matchSearch.id })
    if (found) {
      Object.assign(found, statistics)
    } else {
      state.matchsActionsStatistics.push(statistics)
    }
  },
  loadMatchActionsStopwatch (state, match) {
    const actions = state.actions.filter(
      (action) => action.matchId === match.id && action.active === true && action.date && action.canceled === false && [21, 22].indexOf(action.typeId) > -1
    ).sort(
      (a, b) => a.date.getTime() - b.date.getTime()
    )

    match.dateOffsetFirst = 0
    match.dateOffsetSecond = 0
    match.dateOffsetThird = 0
    match.dateOffsetFourth = 0
    match.dateOffsetFifth = 0

    match.dateOffsetsFirst = []
    match.dateOffsetsSecond = []
    match.dateOffsetsThird = []
    match.dateOffsetsFourth = []
    match.dateOffsetsFifth = []

    let value = 0
    for (const i in actions) {
      const action = actions[i]
      if (action.typeId === 21) {
        value = action.date.getTime()
      } else {
        value = (value - action.date.getTime())

        switch (action.statusId) {
          case 7:
            match.dateOffsetFirst = (match.dateOffsetFirst + value)
            match.dateOffsetsFirst.push({ date: action.date.getTime(), value: value })
            break
          case 8:
            match.dateOffsetSecond = (match.dateOffsetSecond + value)
            match.dateOffsetsSecond.push({ date: action.date.getTime(), value: value })
            break
          case 9:
            match.dateOffsetThird = (match.dateOffsetThird + value)
            match.dateOffsetsThird.push({ date: action.date.getTime(), value: value })
            break
          case 10:
            match.dateOffsetFourth = (match.dateOffsetFourth + value)
            match.dateOffsetsFourth.push({ date: action.date.getTime(), value: value })
            break
          case 11:
            match.dateOffsetFifth = (match.dateOffsetFifth + value)
            match.dateOffsetsFifth.push({ date: action.date.getTime(), value: value })
        }
      }
    }
  }
}
